module.exports = __webpack_public_path__ + "img/settings_filled_24.99eb9e42.svg";